import { render, staticRenderFns } from "./FichaClinicaAssinatura.vue?vue&type=template&id=30f6b8c7&"
import script from "./FichaClinicaAssinatura.vue?vue&type=script&lang=js&"
export * from "./FichaClinicaAssinatura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpandTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VExpandTransition})
